<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    variant?: 'investor' | 'banker'
  }>(),
  {
    variant: 'investor',
  },
)
</script>

<template>
  <div class="fixed inset-0 overflow-hidden">
    <div
      class="auth-background h-screen w-full"
      :class="props.variant === 'banker' ? 'auth-background-banker' : 'auth-background-investor'" />

    <i
      v-if="props.variant === 'investor'"
      class="pi pi-arrow-down-left-and-arrow-up-right-to-center pointer-events-none absolute top-1/2 left-[75%] -translate-x-1/2 -translate-y-1/2 text-black"
      style="font-size: 50vh; opacity: 0.03"
      aria-hidden="true" />

    <i
      v-if="props.variant === 'banker'"
      class="pi pi-building-columns pointer-events-none absolute top-1/2 left-[75%] -translate-x-1/2 -translate-y-1/2 text-black"
      style="font-size: 50vh; opacity: 0.03"
      aria-hidden="true" />
  </div>
</template>

<style scoped>
.auth-background {
  mix-blend-mode: normal;
}

.auth-background-investor {
  background:
    radial-gradient(
      at 70% 35%,
      color-mix(in srgb, var(--color-brand-green-1) 12%, var(--color-surface)) 0,
      transparent 60%
    ),
    radial-gradient(
        at 40% 70%,
        color-mix(in srgb, var(--color-brand-blue-2) 12%, var(--color-surface)) 0,
        transparent 50%
      )
      var(--color-surface);
}

.auth-background-banker {
  background:
    radial-gradient(
      at 70% 35%,
      color-mix(in srgb, var(--color-brand-green-1) 8%, var(--color-surface)) 0,
      transparent 60%
    ),
    radial-gradient(
        at 40% 70%,
        color-mix(in srgb, var(--color-brand-blue-2) 8%, var(--color-surface)) 0,
        transparent 50%
      )
      var(--color-surface);
}
</style>
